import { Component, Inject, Injector } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { UiHelper } from '../../../helpers/ui.helper';
import { STORAGE_LANG_KEY } from '../../../constants/common.constant';
import { WalletService } from '../../../services/wallet.service';
import { DialogInterface } from '../../../shared/dialog/dialog.interface';
import {
  ERROR_BANK_ACCOUNT_NOT_FOUND,
  ERROR_BANK_ACCOUNT_NOT_VERIFIED,
  ERROR_MINIMUM_WITHDRAW,
  ERROR_WALLET_NOT_FOUND,
  ERROR_WITHDRAW_AMOUNT_GREATER_THAN_BALANCE,
  ERROR_WITHDRAW_AMOUNT_LESS_THAN_HUNDRED_THOUSAND,
} from '../../../constants/error.constant';
import { LabelHelper } from '../../../helpers/label.helper';
import { MEMBER_WALLET_LANDING_PAGE } from '../../../constants/route.constant';
import { DialogScrollComponent } from '../../../shared/dialog/dialog-scroll.component';
import { BaseComponent } from 'src/app/shared/base/base.component';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';

const LS_WITHDRAW_EXPIRED = 'withdraw-verification-timer';

@Component({
  selector: 'app-wallet-withdraw-dialog',
  templateUrl: './wallet-dialog-withdraw.component.html',
})
export class MemberWalletWithdrawDialogComponent extends BaseComponent {
  public ui = UiHelper;
  public label = LabelHelper;
  public locale = localStorage.getItem(STORAGE_LANG_KEY);

  public isVerification = false;
  private hashCode = '';
  public isLoadingWithdraw = false;
  public displayTime: string | null = null;

  public verifyFG: UntypedFormGroup;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<MemberWalletWithdrawDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private walletService: WalletService,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder
  ) {
    super(injector);
    this.verifyFG = this.formBuilder.group({
      verifyCode: ['', [Validators.required]],
    });
  }

  async errorHandler(err: any) {
    if (err.error.error) {
      switch (this.ui.errorMessageTransform(err.error.error)) {
        case ERROR_WITHDRAW_AMOUNT_LESS_THAN_HUNDRED_THOUSAND: {
          const message = await this.label.getLabel(
            this.translateService,
            ERROR_WITHDRAW_AMOUNT_LESS_THAN_HUNDRED_THOUSAND
          );
          this.snackBar.open(message as string, '', { duration: 2000 });
          break;
        }
        case ERROR_WITHDRAW_AMOUNT_GREATER_THAN_BALANCE: {
          this.openInsuficientBalanceDialog();
          break;
        }
        case ERROR_BANK_ACCOUNT_NOT_VERIFIED: {
          const message = await this.label.getLabel(
            this.translateService,
            ERROR_BANK_ACCOUNT_NOT_VERIFIED
          );
          this.snackBar.open(message as string, '', { duration: 2000 });
          break;
        }
        case ERROR_WALLET_NOT_FOUND: {
          const message = await this.label.getLabel(
            this.translateService,
            ERROR_WALLET_NOT_FOUND
          );
          this.snackBar.open(message as string, '', { duration: 2000 });
          break;
        }
        case ERROR_BANK_ACCOUNT_NOT_FOUND: {
          const message = await this.label.getLabel(
            this.translateService,
            ERROR_BANK_ACCOUNT_NOT_FOUND
          );
          this.snackBar.open(message as string, '', { duration: 2000 });
          break;
        }
        default: {
          const message = await this.label.getLabel(
            this.translateService,
            ERROR_MINIMUM_WITHDRAW
          );
          this.snackBar.open(message as string, '', { duration: 2000 });
          break;
        }
      }
    } else {
      const message = await this.label.getLabel(
        this.translateService,
        ERROR_MINIMUM_WITHDRAW
      );
      this.snackBar.open(message as string, '', { duration: 2000 });
    }
  }

  send(): void {
    this.walletService.send2FA(Number(this.data.amount)).then(
      (res) => {
        this.isVerification = true;
        this.hashCode = res.hash_code;
        localStorage.setItem(
          LS_WITHDRAW_EXPIRED,
          moment().add(2, 'minutes').toISOString()
        );
        this.startTimer();
        this.snackBar.open(
          `Kode verifikasi sudah dikirim ke email ${
            this.userProfile.basic.email ?? 'kamu'
          }`,
          '',
          { duration: 2000 }
        );
      },
      async (err) => {
        this.errorHandler(err);
      }
    );
  }

  handleResend() {
    if (!this.displayTime) {
      this.send();
    }
  }

  verify() {
    this.walletService
      .verify2FA({
        hash_code: this.hashCode,
        verification_code: this.verifyFG.controls.verifyCode.value,
      })
      .then(
        (res) => {
          this.isLoadingWithdraw = true;
          this.walletService.saveWithdrawRequest(res.verification_hash).then(
            () => {
              this.dialogRef.close();
              this.openSuccessDialog();
              this.displayTime = null;
              this.isLoadingWithdraw = false;
              localStorage.removeItem(LS_WITHDRAW_EXPIRED);
            },
            async (err) => {
              this.errorHandler(err);
              this.isLoadingWithdraw = false;
              this.dialogRef.close();
            }
          );
        },
        async (err) => {
          this.errorHandler(err);
        }
      );
  }

  startTimer() {
    const date = localStorage.getItem(LS_WITHDRAW_EXPIRED);
    if (date) {
      const minute = Math.abs(moment().diff(moment(date), 'minute')) + 1;
      let seconds: number = minute * 60;
      let statSec: number = minute * 60;

      const timer = setInterval(() => {
        seconds--;
        if (statSec != 0) statSec--;
        else statSec = 59;

        this.displayTime = `${statSec}d`;

        if (seconds <= 0) {
          this.displayTime = null;
          localStorage.removeItem(LS_WITHDRAW_EXPIRED);
          clearInterval(timer);
        }
      }, 1000);
    }
  }

  openSuccessDialog(): void {
    const data: DialogInterface = {
      title: 'Terimakasih telah melakukan konfirmasi penarikan dana',
      content:
        'Penarikan memerlukan proses pengecekan dan akan diproses dalam waktu 1x24jam. Danamu akan otomatis masuk ke rekening kamu jika transaksi penarikanmu sudah diverifikasi oleh ramerame',
      imageUrl: 'assets/images/icons/success@2x.png',
      buttons: [
        {
          label: 'Oke, Terima Kasih',
          value: 1,
          className: 'primary-button big-button',
        },
      ],
    };
    const dialogRef = this.dialog.open(DialogScrollComponent, {
      data,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate([MEMBER_WALLET_LANDING_PAGE]).then(() => {});
    });
  }

  openInsuficientBalanceDialog(): void {
    const data: DialogInterface = {
      title: 'Saldo tidak mencukupi',
      content:
        'Transaksi penarikan tidak dapat di proses, saldo anda tidak mencukupi',
      buttons: [
        { label: 'Oke', value: 1, className: 'primary-button big-button' },
      ],
    };
    this.dialog.open(DialogScrollComponent, {
      data,
      panelClass: 'error-dialog',
    });
  }
}
